import { render, staticRenderFns } from "./tourServer.vue?vue&type=template&id=1818a392&scoped=true&"
import script from "./tourServer.vue?vue&type=script&lang=js&"
export * from "./tourServer.vue?vue&type=script&lang=js&"
import style0 from "./tourServer.vue?vue&type=style&index=0&id=1818a392&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1818a392",
  null
  
)

export default component.exports